<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="6">
        <v-card>
          <v-card-title>Grup Düzenle</v-card-title>

          <v-card-text>
            <v-card outlined>
              <v-card-subtitle>Üyeler</v-card-subtitle>

              <v-card-text>
                <v-text-field label="Filtre"></v-text-field>

                <v-list>
                  <v-list-item-group v-model="selectedMembers" multiple>
                    <v-list-item
                      v-for="member in members"
                      :key="member.name"
                      :value="member"
                    >
                      <template #default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active"></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{
                            member.name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>

              <v-card-actions>
                <v-btn color="primary"> <v-icon left>add</v-icon>Ekle </v-btn>

                <v-btn
                  color="error"
                  :disabled="!selectedMembers.length"
                  @click="removeDialog = !removeDialog"
                >
                  <v-icon left>delete</v-icon>Kaldır
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary">Tamam</v-btn>
            <v-btn text @click="$router.go(-1)" color="primary">İptal</v-btn>
            <v-btn text color="primary">Uygula</v-btn>
          </v-card-actions>
        </v-card>

        <v-dialog v-model="removeDialog" max-width="500px">
          <v-card>
            <v-card-title>Üye(leri) Sil</v-card-title>
            <v-card-text>
              Seçili tüm kullanıcıları bu gruptan kaldırmak istediğinize emin
              misiniz?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary">Evet</v-btn>
              <v-btn text color="primary">Hayır</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      members: [{ name: "sven" }, { name: "peter" }],
      selectedMembers: [],
      removeDialog: false,
    };
  },
  methods: {},
};
</script>
